
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modify",
      function () {
        return require("private-next-pages/modify.tsx");
      }
    ]);
  